<div>
  <mat-card class="mat-elevation-z8">
    <mat-card-content>
      <pdf-viewer [src]="pdfSrc" [render-text]="true"> </pdf-viewer>
    </mat-card-content>
  </mat-card>
</div>
